import { omit, set } from 'lodash';
import { mapAxiosResponse } from "../utils/api-utils";
import EnrouteApiClient from './enroute-api-client';
import { Organization, OrganizationConfig, ConfigUpdateItem } from '../models/organization';

export default class OrganizationService {
  static async getOrg(orgId: number, includeConfig?: boolean, includeChildren?: boolean) {
    let children = [];
    const params = includeConfig ? { config: includeConfig} : null;

    const resp = await EnrouteApiClient.get(`org/${orgId}`, { params });

    if (includeChildren) {
      const childrenResp = await EnrouteApiClient.get(`org/${orgId}/children`, { params });
      children = mapAxiosResponse<Organization[]>(childrenResp);
    }
    
    const org = mapAxiosResponse<Organization>(resp);
    
    return {
      ...org,
      children,
    };
  }

  static async getOrgHierarchy(orgId: number) {

    const resp = await EnrouteApiClient.get(`org/${orgId}/tree`);

    return mapAxiosResponse<any>(resp);
  }

  static async getOrgChildren(orgId: number) {

    const resp = await EnrouteApiClient.get(`org/${orgId}/children`);

    return mapAxiosResponse<Organization[]>(resp);
  }

  static async updateConfig(orgID: number, config: OrganizationConfig, updates: ConfigUpdateItem[]) {
    if (updates) {
      updates.map(update => set(config, update.path, update.value));
    }

    const updatedConfig = omit(config, ['_id', 'org_id', 'created_time', 'last_modified']);

    await EnrouteApiClient.post(`org/${ orgID }/config/update`, updatedConfig);
  }

  static async refreshBillingSubscription(subscriptionId: string) {

    const resp = await EnrouteApiClient.get(`psp/subscriptions/${subscriptionId}`);
    return resp;
  }

  static async syncBillingSubscription(hostedPageID: string) {

    const resp = await EnrouteApiClient.get(`psp/hosted_pages/${hostedPageID}/subscription`);
    return resp;
  }

  static async editOrg(orgID: number, updates: any) {

    const resp = await EnrouteApiClient.post(`org/${ orgID }/update`, {
      ...updates
    });

    return mapAxiosResponse<Organization>(resp);
  }

  static async getOrgDescendants() {
    const resp = await EnrouteApiClient.get(`orgs/list`, {
      params: {
        children: true,
      }
    });

    return mapAxiosResponse<Organization[]>(resp);
  }

  static async getOrgList() {

    const resp = await EnrouteApiClient.get(`orgs/list?children=true`);

    return mapAxiosResponse<Organization[]>(resp);
  }


  static async createOrg(parentId: number, orgName: string, adminEmail: string, tags: string[], info: any, referrerOrgId?: number) {

    const resp = await EnrouteApiClient.post(`orgs/create_organization?parent_id=${parentId}`, {
      admin_email: adminEmail,
      tags,
      name: orgName,
      info,
      ...(referrerOrgId && { referrer_org_id: referrerOrgId }),
    });

    return mapAxiosResponse<Organization>(resp);

  }
}
